// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"452":"8848843b","598":"9c815eb7"}[chunkId] + ".css";
};